var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-927 -52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(927 52)",
    fill: "#3c3838",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.955,2.353A.571.571,0,0,0,17.429,2H12.857a.571.571,0,1,0,0,1.143h3.192L11.31,7.881a.571.571,0,1,0,.808.808l4.739-4.738V7.143a.571.571,0,1,0,1.143,0V2.571A.557.557,0,0,0,17.955,2.353ZM2.571,12.286A.571.571,0,0,0,2,12.857v4.574a.561.561,0,0,0,.162.4s0,0,0,.007,0,0,0,0a.567.567,0,0,0,.4.163H7.143a.571.571,0,1,0,0-1.143H3.951l4.738-4.738a.571.571,0,1,0-.808-.808L3.143,16.049V12.857A.571.571,0,0,0,2.571,12.286Z",
    transform: "translate(932 57)",
    fill: "#3c3838"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon1);
export default __webpack_public_path__ + "static/media/expand-icon-1.3eefc9eebc17aa31bc5c64c309ab9e51.svg";
export { ForwardRef as ReactComponent };